import { DateTime } from 'luxon';
import type { IAccount } from '../../../../../../models/pa-egna-ben/account.model';
import { UserApiModel } from '../../../../models/user.api-model';
import ParticipationApiModel from '../../../../models/participation.api-model';

export class AccountApiModel {
  scimId!: string;
  firstName!: string;
  lastName!: string;
  emailAddress!: string;
  createdAt!: string;
  user: UserApiModel | undefined;
  participations: ParticipationApiModel[] | undefined;

  static mapToBusinessModel(apiModel: AccountApiModel): IAccount {
    return {
      scimId: apiModel.scimId,
      firstName: apiModel.firstName,
      lastName: apiModel.lastName,
      emailAddress: apiModel.emailAddress,
      createdAt: apiModel.createdAt ? DateTime.fromISO(apiModel.createdAt) : undefined,
      user: apiModel.user ? UserApiModel.mapToBusinessModel(apiModel.user) : undefined,
      participations: apiModel.participations?.map((p) => ParticipationApiModel.mapToBusinessModel(p)) ?? [],
    };
  }
}

